import { render, staticRenderFns } from "./HealthQuestion.vue?vue&type=template&id=624f5d74"
import script from "./HealthQuestion.vue?vue&type=script&lang=js"
export * from "./HealthQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports